<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <HerosForm @submit-requested="submitRequested"></HerosForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import HerosForm from './HerosForm.vue'

  export default {
  components: { HerosForm },
  methods: {
    ...mapActions('heros', ['postHero']),
    submitRequested (input) {
      this.postHero(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 